import * as yup from "yup";

export const createNotificationSchema = (v, t, isEditMode) => {
  return yup.object().shape({
    userName: v.string().when("notificationType", {
      is: "1",
      then: (schema) => schema.required(t("thisFieldIsRequired")),
      otherwise: (schema) => schema.notRequired(),
    }),
     mobileNumber: v.string().when("notificationType", {
      is: "1",
      then: (schema) => schema.required(t("mobileNumberIsRequired")),
      otherwise: (schema) => schema.notRequired(),
    }),
    title: v.string().required(),
    message: v.string().required(),
  });
};
